import { render } from "./ai-top-menu.vue?vue&type=template&id=20f168dd&scoped=true"
import script from "./ai-top-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-top-menu.vue?vue&type=script&setup=true&lang=js"

import "./ai-top-menu.vue?vue&type=style&index=0&id=20f168dd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f168dd"],['__file',"src/layouts/main-layout/components/top-menu/ai-top-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f168dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f168dd', __exports__)) {
    api.reload('20f168dd', __exports__)
  }
  
  module.hot.accept("./ai-top-menu.vue?vue&type=template&id=20f168dd&scoped=true", () => {
    api.rerender('20f168dd', render)
  })

}


export default __exports__